// test756
(756 && 0);
